import {
  BRAND_MODEL_MAX_CHARACTER_LENGTH,
  VEHICLE_TYPE,
} from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/vehicleConstants";
import {
  TrailerProductIntroFormValues,
  TrailerTexts,
} from "../trailerInterface";

import { Input } from "Components/Form/Input";
import { InputMode } from "Components/Form/Input/inputTypes";
import { Select } from "Components/Form/Select";
import { TextLanguage } from "Store/texts/interfaces";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";
import { getValidRegistrationYearOptions } from "../../vehicleUtils";

interface Props {
  formProps: FormikProps<TrailerProductIntroFormValues>;
  texts: TrailerTexts["formText"]["checkPrice"];
  lang: TextLanguage;
}

export const FormElements = (props: Props): React.ReactElement => {
  const { texts, lang, formProps } = props;

  const yearOptions = getValidRegistrationYearOptions(VEHICLE_TYPE.TRAILER);
  // Temporary solution for placeholder as necessary logic
  // inside of Select requires a major bumb to alpha of 3.0.0
  const placeholder = {
    value: "",
    label: texts.registrationYear?.placeholder?.[lang] ?? "",
  };

  return (
    <>
      <Select
        id="registrationYear"
        name="registrationYear"
        label={texts.registrationYear?.label[lang]}
        options={[placeholder, ...yearOptions]}
        hint={texts.registrationYear?.hint?.[lang]}
        error={getError("registrationYear", formProps)}
        large
      />
      <Input
        id="brand"
        name="brand"
        label={texts.brand?.label[lang]}
        placeholder={texts.brand?.placeholder?.[lang]}
        error={getError("brand", formProps)}
        large
        inputProps={{ maxLength: BRAND_MODEL_MAX_CHARACTER_LENGTH }}
        inputMode={InputMode.TEXT}
      />
      <Input
        id="model"
        name="model"
        label={texts.model?.label[lang]}
        error={getError("model", formProps)}
        large
        inputProps={{ maxLength: BRAND_MODEL_MAX_CHARACTER_LENGTH }}
        inputMode={InputMode.TEXT}
      />
    </>
  );
};
